import { handleResponse } from "../../../../common/handleLambdaResponse";
import { getIdToken } from "../../../userManager/userManagementUtils";

export const aoiIndexAdd = (inData : string, inName : string, dataInfo : any) => {
    return new Promise(async (resolve, reject) => {
        
        if(window.activeProjection === null) return
        let crs = window.activeProjection.getCRS();

        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            resolve(false);
            return
        }
        const params = {
            FunctionName: "aoi-index",
            Payload: JSON.stringify({
                action: "add",
                token: idToken,
                polygon: inData,
                crs: crs,
                name: inName,
                data : dataInfo
            })
        };

        // eslint-disable-next-line complexity
        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });
    });
    
}

export const aoiIndexList = (lastEvaluatedKey: any) => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            resolve(false);
            return
        }
        const payload = {
            action: "list",
            token: idToken
        }
        if (lastEvaluatedKey) {
            // @ts-ignore
            payload.exclusive_start_key = lastEvaluatedKey
        }
        const params = {
            FunctionName: "aoi-index",
            Payload: JSON.stringify(payload)
        };

        // eslint-disable-next-line complexity
        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });

    });
    
}

export const aoiIndexDelete = (in_h3_index : any) => {
    return new Promise(async (resolve, reject) => {
        let idToken;
        try {
            idToken = await getIdToken();
        } catch (err) {
            resolve(false);
            return
        }
        const params = {
            FunctionName: "aoi-index",
            Payload: JSON.stringify({
                action: "delete",
                token: idToken,
                h3_index: in_h3_index
            })
        };

        // eslint-disable-next-line complexity
        window.lambda.invoke(params, async (err: any, resp: any) => {
            handleResponse(err, resp, resolve, reject);
        });

    });

}